/**
 * Microphone button that triggers the voice conversation overlay.
 */

import { Mic } from "lucide-react";
import { Button } from "@/components/ui/button";

interface VoiceButtonProps {
  disabled?: boolean;
  onClick: () => void;
}

export function VoiceButton({ disabled = false, onClick }: VoiceButtonProps) {
  return (
    <Button
      type="button"
      size="icon"
      variant="ghost"
      disabled={disabled}
      onClick={onClick}
      className="shrink-0 text-white/50 hover:text-teal-400 hover:bg-white/[0.05] transition-colors"
      title="Start voice conversation"
    >
      <Mic className="h-4 w-4" />
    </Button>
  );
}
